import { useQuery } from 'react-query'
import axios from '../../../utils/http/axios-local'
import { NONE_MERCHANT } from '../context/merchant-context'

export const useDisputesAffected = (
  templateId: number,
  merchantId?: number
) => {
  let url = `/det/tooling/templates/${templateId}/disputes_usage_count`
  if (merchantId && merchantId !== NONE_MERCHANT.id) {
    url += `?merchant_id=${merchantId}`
  }
  const {
    data: { data: { count } = {} } = {},
    isLoading,
    refetch
  } = useQuery(
    `disputes-affected-${templateId}-${merchantId}`,
    () => axios.get<{ count: number }>(url),
    {
      refetchOnWindowFocus: false,
      retry: false
    }
  )

  return {
    count,
    isLoading,
    refetch
  }
}
